export const UNPROTECTED_ROUTES = [
  '/ui/sign_up',
  '/ui/sign_in',
  '/ui/confirm_email',
  '/ui/reset_password',
  '/ui/invitation',
];
